import { useEffect } from 'react';

// Client-side <head> management. Vite ships a SPA, so we set per-page title +
// meta on mount. Modern crawlers (incl. Google) execute JS and read these.
// True SSR/pre-render is a documented future enhancement (see README).
function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function Seo({ title, description, image, locale }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', image ? 'article' : 'website');
    upsertMeta('property', 'og:url', window.location.href);
    if (image) upsertMeta('property', 'og:image', image);
    if (locale) upsertMeta('property', 'og:locale', { fr: 'fr_BE', nl: 'nl_BE', en: 'en_GB' }[locale] || 'fr_BE');
    upsertMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    if (image) upsertMeta('name', 'twitter:image', image);
  }, [title, description, image, locale]);

  return null;
}
